/**
 * @mfa/domain — business vocabulary shared by every client.
 *
 * Holds the things that must not drift between the donor app, the admin portal
 * and the server: the status enum and its labels, money and date formatting,
 * the API contracts, and the validation and state-machine rules.
 *
 * No I/O, no React, no platform APIs — importable from anywhere.
 */

export * from './status';
export * from './format';
export * from './contracts';
export * from './donation';
export * from './tiffin';
